// COMMENT BY KHALID TO REDUCE SIGNATURE STEPS STARTS

// import React, { useEffect, useRef, useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { setSignature } from '../redux-store/slices/usersData';
// import { toast } from 'react-toastify';

// const boxStyle = {
//   height: "100%",
//   width: "100%",
//   border: "1px solid #d3d3d3",
// };

// function FormElements({ handleClose }) {
//   const signer = {
//     firstName: "User",
//     lastName: "Signature"
//   };

//   const btnRestore = useRef();
//   const chkB64 = useRef();
//   const chkSigText = useRef();
//   const firstName = useRef("");
//   const lastName = useRef("");
//   const imageBox = useRef();
//   const txtSignature = useRef();
//   const txtDisplay = useRef();
//   const dispatch = useDispatch();

//   const [chkValue, setChecked] = useState(false);
//   const [imageSrc, setImageSrc] = useState('');
//   const [isSignatureSaved, setIsSignatureSaved] = useState(false);

//   const setRestoreButtonState = (buttonState) => {
//     setChecked(buttonState);
//     document.getElementById("Restore").disabled = buttonState;
//   };

//   const handleCapture = () => {
//     const imgElement = imageBox.current.querySelector("img");
//     if (imgElement) {
//       const imageData = imgElement.src;
//       dispatch(setSignature(imageData));
//       console.log('Image data: handleCapture', imageData);
//       toast.success('Signature is saved successfully');
//       handleClose();
//     }
//   };

//   useEffect(() => {
//     document.getElementById("Restore").disabled = true;
//   }, []);

//   useEffect(() => {
//     const imgElement = imageBox.current.querySelector("img");
//     if (imgElement && imgElement.src) {
//       const imageData = imgElement.src;
//       dispatch(setSignature(imageData));
//       console.log('Image data:', imageData);
//     }
//   }, []);

//   return (
//     <div className="container mx-auto px-4">
//       <br /><br />
//       <div className="flex justify-center mb-2">
//         <div className="w-full md:w-10/12">
//           <div className="flex justify-between">
//             <div className="w-full md:w-1/2">
//               <div id="imageBox" ref={imageBox} style={boxStyle} title="Double-click a signature to display its details"></div>
//             </div>
//             <div className="w-full md:w-1/2 px-3">
//               <div className="mb-2">
//                 <button className="bg-blue-500 text-white w-full py-2" title="Capture a signature" onClick={() => { window.capture(firstName.current, lastName.current, imageBox.current, txtSignature.current, chkSigText.current, chkB64.current); }}>Open SignaturePad</button>
//               </div>
//               <div className="mb-2">
//                 <button className="bg-green-500 text-white w-full py-2" title="Checks the signature hash" onClick={handleCapture}>Save Signature</button>
//               </div>
//               <div className="mb-2 hidden">
//                 <button className="btn btn-primary w-full py-2" title="Checks the signature hash" onClick={() => (window.verifySignedData())}>Verify</button>
//               </div>
//               <div className="mb-2 hidden">
//                 <button className="btn btn-primary w-full py-2" title="Displays capture details of the signature" onClick={() => (window.displaySignatureDetails())}>Details</button>
//               </div>
//               <div className="mb-2 hidden">
//                 <button className="bg-yellow-500 text-white w-full py-2" title="Displays the Help About box" onClick={() => (window.aboutBox())}>License</button>
//               </div>
//               <div className="mb-2">
//                 <button className="bg-red-500 text-white w-full py-2" title="Clears the signature" onClick={() => (window.clearSignature())}>Clear</button>
//               </div>
//               <div className="mb-2 hidden">
//                 <button id="Restore" className="bg-yellow-500 text-white w-full py-2" ref={btnRestore} title="Restores the signature from the SigText data. To use this function please tick Output SigText to form" onClick={() => (window.setSignatureText())} disabled>Restore</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className=" justify-center hidden">
//         <div className="w-full md:w-10/12">
//           <div className="flex justify-around">
//             <div className="w-full md:w-1/4">
//               <b>Data included in the hash: </b>
//               <input id="fname" className="form-control mb-2 border p-2 w-full" ref={firstName} defaultValue={signer.firstName} />
//               <input id="lname" className="form-control mb-4 border p-2 w-full" ref={lastName} defaultValue={signer.lastName} />
//             </div>
//             <div className="w-full md:w-1/4">
//               <b>Options:</b>
//               <br />
//               <input type="checkbox" id="chkUseB64Image" className="form-check-input mb-2" ref={chkB64} />
//               <label className="form-check-label" htmlFor="chkUseB64Image">Use base-64 signature image</label>
//               <br />
//               <input type="checkbox" id="chkShowSigText" className="form-check-input mb-4" onChange={() => setRestoreButtonState(chkSigText.current.checked)} ref={chkSigText} />
//               <label className="form-check-label" htmlFor="chkShowSigText">Output SigText to form</label>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="flex justify-center">
//         <div className="w-full md:w-10/12">
//           <textarea className="form-control border p-2 w-full" cols="125" rows="9" id="txtDisplay" ref={txtDisplay}></textarea>
//           <br />
//           <div className='hidden'>
//             <br />SigText:<br />
//             <textarea className="form-control border p-2 w-full" cols="125" rows="15" id="txtSignature" ref={txtSignature}></textarea>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// function Signature({ handleCloseSignature }) {
//   useEffect(() => {
//     window.bodyOnLoad(document.getElementById("txtDisplay"), document.getElementById("chkShowSigText"), document.getElementById("Restore"));
//   }, []);

//   return (
//     <FormElements handleClose={handleCloseSignature} />
//   );
// }

// export default Signature;

// COMMENT BY KHALID TO REDUCE SIGNATURE STEPS ENDS

// NEW CODE BY KHALID TO REDUCE SIGNATURE STEPS STARTS

import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSignature } from "../redux-store/slices/usersData";
import { toast } from "react-toastify";

const boxStyle = {
  height: "100%",
  width: "100%",
  border: "1px solid #d3d3d3",
};

function FormElements({ handleClose }) {
  const signer = {
    firstName: "User",
    lastName: "Signature",
  };

  const btnRestore = useRef();
  const chkB64 = useRef();
  const chkSigText = useRef();
  const firstName = useRef("");
  const lastName = useRef("");
  const imageBox = useRef();
  const txtSignature = useRef();
  const txtDisplay = useRef();
  const dispatch = useDispatch();

  const [chkValue, setChecked] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [isSignatureSaved, setIsSignatureSaved] = useState(false);

  const setRestoreButtonState = (buttonState) => {
    setChecked(buttonState);
    document.getElementById("Restore").disabled = buttonState;
  };

  const handleCapture = () => {
    const imgElement = imageBox.current.querySelector("img");
    if (imgElement) {
      const imageData = imgElement.src;
      dispatch(setSignature(imageData));
      console.log("Image data: handleCapture", imageData);
      toast.success("Signature is saved successfully");
      handleClose();
    }
  };

  useEffect(() => {
    document.getElementById("Restore").disabled = true;
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const imgElement = imageBox.current.querySelector("img");
      if (imgElement && imgElement.src && !isSignatureSaved) {
        const imageData = imgElement.src;
        dispatch(setSignature(imageData));
        toast.success("Signature saved automatically");
        setIsSignatureSaved(true);
        handleClose(); // Auto-close popup
        observer.disconnect(); // Stop observing
      }
    });

    if (imageBox.current) {
      observer.observe(imageBox.current, { childList: true, subtree: true });
    }

    return () => observer.disconnect();
  }, [isSignatureSaved]);

  return (
    <div className="container mx-auto px-4">
      <br />
      <br />
      <div className="flex justify-center mb-2">
        <div className="w-full md:w-10/12">
          <div className="flex justify-between">
            <div className="w-full md:w-1/2">
              <div
                id="imageBox"
                ref={imageBox}
                style={boxStyle}
                title="Double-click a signature to display its details"
              ></div>
            </div>
            <div className="w-full md:w-1/2 px-3">
              <div className="mb-2">
                <button
                  className="bg-blue-500 text-white w-full py-2"
                  title="Capture a signature"
                  onClick={() => {
                    window.capture(
                      firstName.current,
                      lastName.current,
                      imageBox.current,
                      txtSignature.current,
                      chkSigText.current,
                      chkB64.current
                    );
                  }}
                >
                  Open SignaturePad
                </button>
              </div>
              {/* <div className="mb-2">
                <button
                  className="bg-green-500 text-white w-full py-2"
                  title="Checks the signature hash"
                  onClick={handleCapture}
                >
                  Save Signature
                </button>
              </div> */}
              <div className="mb-2 hidden">
                <button
                  className="btn btn-primary w-full py-2"
                  title="Checks the signature hash"
                  onClick={() => window.verifySignedData()}
                >
                  Verify
                </button>
              </div>
              <div className="mb-2 hidden">
                <button
                  className="btn btn-primary w-full py-2"
                  title="Displays capture details of the signature"
                  onClick={() => window.displaySignatureDetails()}
                >
                  Details
                </button>
              </div>
              <div className="mb-2 hidden">
                <button
                  className="bg-yellow-500 text-white w-full py-2"
                  title="Displays the Help About box"
                  onClick={() => window.aboutBox()}
                >
                  License
                </button>
              </div>
              <div className="mb-2">
                <button
                  className="bg-red-500 text-white w-full py-2"
                  title="Clears the signature"
                  onClick={() => window.clearSignature()}
                >
                  Clear
                </button>
              </div>
              <div className="mb-2 hidden">
                <button
                  id="Restore"
                  className="bg-yellow-500 text-white w-full py-2"
                  ref={btnRestore}
                  title="Restores the signature from the SigText data. To use this function please tick Output SigText to form"
                  onClick={() => window.setSignatureText()}
                  disabled
                >
                  Restore
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className=" justify-center hidden">
        <div className="w-full md:w-10/12">
          <div className="flex justify-around">
            <div className="w-full md:w-1/4">
              <b>Data included in the hash: </b>
              <input
                id="fname"
                className="form-control mb-2 border p-2 w-full"
                ref={firstName}
                defaultValue={signer.firstName}
              />
              <input
                id="lname"
                className="form-control mb-4 border p-2 w-full"
                ref={lastName}
                defaultValue={signer.lastName}
              />
            </div>
            <div className="w-full md:w-1/4">
              <b>Options:</b>
              <br />
              <input
                type="checkbox"
                id="chkUseB64Image"
                className="form-check-input mb-2"
                ref={chkB64}
              />
              <label className="form-check-label" htmlFor="chkUseB64Image">
                Use base-64 signature image
              </label>
              <br />
              <input
                type="checkbox"
                id="chkShowSigText"
                className="form-check-input mb-4"
                onChange={() =>
                  setRestoreButtonState(chkSigText.current.checked)
                }
                ref={chkSigText}
              />
              <label className="form-check-label" htmlFor="chkShowSigText">
                Output SigText to form
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center">
        <div className="w-full md:w-10/12">
          <textarea
            className="form-control border p-2 w-full"
            cols="125"
            rows="9"
            id="txtDisplay"
            ref={txtDisplay}
          ></textarea>
          <br />
          <div className="hidden">
            <br />
            SigText:
            <br />
            <textarea
              className="form-control border p-2 w-full"
              cols="125"
              rows="15"
              id="txtSignature"
              ref={txtSignature}
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  );
}

function Signature({ handleCloseSignature }) {
  useEffect(() => {
    const displayRef = document.getElementById("txtDisplay");
    const sigTextRef = document.getElementById("chkShowSigText");
    const restoreRef = document.getElementById("Restore");
    window.bodyOnLoad(displayRef, sigTextRef, restoreRef);
  }, []);

  return <FormElements handleClose={handleCloseSignature} />;
}

export default Signature;
